import React from "react";

import Section from "../../../HOC/Section";
import i1 from "./lazer.webp";
import i2 from "./cilt.webp";
import i3 from "./kasLifting.webp";
import i4 from "./kirpikLifting.webp";
import i5 from "./kalıcıOje.webp";
import i6 from "./pedikür.webp";
import i7 from "./tırnak.webp";
import i8 from "./ayakMantar.webp";

const Service = () => {
  const gold = "#966400";

  return (
    <Section id="services">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>Verilen </span>Hizmetler
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto"></h6>
        </div>
        <div className="section-content">
          <div className="row">
            <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i1}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Lazer Epilasyon
                    </h5>
                    <p className="card-text">
                      Işınların uyarılmasıyla elde edilen ışık demeti olan
                      lazer, tıbbi ve estetik gibi pek çok alanda kullanılır.
                      Kozmetik ve psikososyal bir sorun olan tüylenmenin
                      giderilmesi için kullanılan lazer epilasyon yaklaşık 25
                      senedir uygulanan bir yöntemdir.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i2}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Cilt Bakımı
                    </h5>
                    <p className="card-text">
                      Cildin ihtiyaçlarına uygun ürünleri düzenli olarak
                      kullanarak elde edilen sonuçlar bütünüdür diyebiliriz.
                      Cilt yapısını tanıyıp eksikleri gidermek adına bakım
                      yapmak oldukça önemlidir. Böylece daha sağlıklı görünen,
                      aydınlık ciltlere sahip olunabilir.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i3}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Kaş Lifting
                    </h5>
                    <p className="card-text">
                      Kaş kıllarının formunu ve yönünü değiştirmek amacıyla özel
                      sabitleyici solüsyonlar kullanılarak yapılan, kaşlara daha
                      düzenli ve dolgun bir görünüm kazandıran bir prosedürdür.
                      Kaşların asimetrisini gidererek yüz hatlarını daha
                      belirgin hale getirir.
                    </p>
                  </div>
                </div>
              </div>
            </div>
           
             <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i7}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Protez Tırnak
                    </h5>
                    <p className="card-text">
                      Tırnak yatağı bozukluklarını maskelemek veya estetik
                      uzatma sağlamak amacıyla, tırnağın üzerine jel veya
                      akrilik materyallerin uygulanmasıyla yapılan bir işlemdir.
                      Kişinin kendi tırnağına zarar vermeden doğal ve güçlü bir
                      görünüm oluşturulur.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i5}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Kalıcı Oje
                    </h5>
                    <p className="card-text">
                      Özel formülasyonlu jel cilaların tırnağa uygulanması ve UV
                      veya LED lambalar altında kürlenmesiyle gerçekleştirilen,
                      uzun süreli dayanıklılık sağlayan bir yöntemdir. Klasik
                      ojelere kıyasla haftalarca parlaklığını ve bütünlüğünü
                      koruyan bir işlemdir.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i6}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Manikür & Pedikür
                    </h5>
                    <p className="card-text">
                      El ve ayak tırnaklarının sağlıklı uzamasını desteklemek,
                      kütikülleri temizlemek ve deri bütünlüğünü korumak
                      amacıyla yapılan profesyonel bir hijyenik bakım
                      prosedürüdür. Tırnak plağının şekillendirilmesi ve
                      yumuşatılması aşamalarını içerir.
                    </p>
                  </div>
                </div>
              </div>
            </div>

             <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i8}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Ayak Mantar Tedavisi
                    </h5>
                    <p className="card-text">
                      Tinea pedis olarak adlandırılan ve ayak derisinde
                      enfeksiyona yol açan dermatofit tipi mantarların
                      eliminasyonu için uygulanan tıbbi bir bakım sürecidir.
                      Tedavi, antimikotik ajanlar ve hijyenik prosedürler ile
                      enfeksiyonun giderilmesini hedefler.
                    </p>
                  </div>
                </div>
              </div>
            </div>

             <div className="col-md-12 col-lg-6">
              <div className="service-box d-flex">
                <div className="card">
                  <img
                    src={i4}
                    className="card-img-top"
                    style={{ width: "%100", height: "350px" }}
                    alt="..."
                  ></img>
                  <div className="card-body">
                    <h5
                      className="service-title"
                      style={{ color: gold, fontWeight: "bold" }}
                    >
                      Kirpik Lifting
                    </h5>
                    <p className="card-text">
                      Kişinin kendi doğal kirpiklerine keratin bazlı solüsyonlar
                      uygulanarak, kirpiklerin kökten itibaren yukarı doğru
                      kıvrılmasını ve daha hacimli görünmesini sağlayan bir
                      işlemdir. Bu yöntem, kirpiklere doğal bir lift etkisi ve
                      derinlik katar.
                    </p>
                  </div>
                </div>
              </div>
            </div>

          

           

          </div>
          <div className="section-content">
            <div className="row">
              <div className="col-md-12 col-lg-12 mb-12">
                <br />
                <ul className="list-group">
                  <li
                    className="list-group-item active"
                    aria-current="true"
                    style={{ backgroundColor: gold }}
                  >
                    <b>Lazer Epilasyonun Faydaları</b>
                  </li>
                  <li className="list-group-item">
                    ·        Kalıcı Sonuçlar: Lazer epilasyon, istenmeyen
                    tüyleri kökten yok ederek kalıcı sonuçlar sağlar. Doğru
                    şekilde uygulandığında, tüyler geri gelmez veya çok daha
                    ince ve seyrek olarak yeniden büyür.
                  </li>
                  <li className="list-group-item">
                    ·        Hız ve Verimlilik: Lazer epilasyon, büyük
                    bölgelerde hızlı ve etkili bir şekilde uygulanabilir.
                    Örneğin, bacakları veya sırtı kısa sürede tedavi etmek
                    mümkündür.
                  </li>
                  <li className="list-group-item">
                    ·        Daha Az Ağrı ve Rahatsızlık: Diğer epilasyon
                    yöntemlerine kıyasla, lazer epilasyon daha az ağrılıdır.
                    Ayrıca işlem sırasında genellikle rahatsızlık hissi azdır.
                  </li>
                  <li className="list-group-item">
                    ·        Uzun Vadeli Maliyet Tasarrufu: Kalıcı sonuçlar elde
                    edildiğinde, uzun vadede tıraş bıçakları veya epilasyon
                    kremleri gibi diğer tüy alma yöntemlerine harcanan maliyeti
                    azaltabilir.
                  </li>
                </ul>
                <br />
                <ul className="list-group">
                  <li
                    className="list-group-item active"
                    aria-current="true"
                    style={{ backgroundColor: gold }}
                  >
                    <b>Cilt Bakımının Faydaları</b>
                  </li>
                  <li className="list-group-item">
                    ·        Cildin parlak ve iyi durumda kalması önemlidir.
                  </li>
                  <li className="list-group-item">
                    ·        Cildin nemli ve dengeli kalmasına katkı sağlar.
                  </li>
                  <li className="list-group-item">
                    ·        Cildin sıkı ve eşit tonda kalmasına destek olur
                  </li>
                  <li className="list-group-item">
                    ·        Akne ve toksinlerin neden olabileceği sorunları en
                    aza indirir.
                  </li>
                </ul>
                <br />
                <ul className="list-group">
                  <li
                    className="list-group-item active"
                    aria-current="true"
                    style={{ backgroundColor: gold }}
                  >
                    <b>Kavitasyonun Faydaları</b>
                  </li>
                  <li className="list-group-item">
                    ·        Yağ Kaybı: Kavitasyon, yağ hücrelerinin zarlarını
                    titreterek yağların serbest hale gelmesine ve vücuttan
                    atılmasına yardımcı olur.{" "}
                  </li>
                  <li className="list-group-item">
                    ·        Ses Dalgaları ile Çalışır: Kavitasyon işlemi için
                    yüksek yoğunluklu ses dalgaları kullanılır, bu nedenle
                    cerrahi müdahale veya iğne enjeksiyonları gibi invazif
                    prosedürlerin risklerini ortadan kaldırır.
                  </li>
                  <li className="list-group-item">
                    ·        Vücut Kontürünü İyileştirir: Kavitasyon, istenmeyen
                    yağ birikintilerinin bulunduğu bölgelerde vücut kontürünü
                    düzeltebilir. Özellikle karın, kalça, bacak ve sırt
                    bölgelerinde kullanılan popüler bir teknolojidir.
                  </li>
                  <li className="list-group-item">
                    ·        Kolay Uygulama: Kavitasyon işlemi non-invazif
                    olduğu için ağrısız ve rahattır. İşlem sırasında anestezi
                    veya dikiş gerektirmez.
                  </li>
                </ul>
                <br />
                <ul className="list-group">
                  <li
                    className="list-group-item active"
                    aria-current="true"
                    style={{ backgroundColor: gold }}
                  >
                    <b>G5 Selülit Masajının Faydaları</b>
                  </li>
                  <li className="list-group-item">
                    ·        Selülit Görünümünü Azaltır: G5 Selülit Masajı,
                    selülit olarak bilinen cilt yüzeyinin "portakal kabuğu"
                    görünümünü azaltmada etkili olabilir.
                  </li>
                  <li className="list-group-item">
                    ·        Sıkılaştırıcı Etki: G5 masajı cildin altındaki
                    kolajen üretimini teşvik edebilir. Bu, cilt dokusunun
                    sıkılaşmasına ve daha genç bir görünüm kazanmasına yardımcı
                    olabilir.
                  </li>
                  <li className="list-group-item">
                    ·        Yağ Kaybını Destekler: G5 masajı, yağ hücrelerinin
                    içerisindeki yağları serbest bırakabilir ve lenfatik drenajı
                    uyararak vücuttan atılmasına yardımcı olabilir. Bu, yağ
                    kaybını destekleyebilir.
                  </li>
                  <li className="list-group-item">
                    ·       Dolaşımı İyileştirir: G5 masajı, kan dolaşımını
                    artırır. İyileşmiş kan dolaşımı, dokulara daha fazla oksijen
                    ve besin maddesi taşır ve toksinlerin daha etkili bir
                    şekilde atılmasına yardımcı olabilir.
                  </li>
                </ul>
                <br />
                <ul className="list-group">
                  <li
                    className="list-group-item active"
                    aria-current="true"
                    style={{ backgroundColor: gold }}
                  >
                    <b>Kalıcı Makyajın Faydaları</b>
                  </li>
                  <li className="list-group-item">
                    ·        Cilt İçin Daha Az Kimyasal Kullanımı: Kalıcı
                    makyaj, günlük makyaj ürünlerinin kullanımını azaltır. Bu,
                    cildinizin daha az kimyasala maruz kalmasını sağlar.
                  </li>
                  <li className="list-group-item">
                    ·        Kusursuz Dudak Renkleri: Kalıcı makyaj, dudaklara
                    doğal ve kusursuz bir renk verir. Dudak kontürünü
                    belirginleştirir ve dudaklara hacim katar.
                  </li>
                  <li className="list-group-item">
                    ·        Saatlerce Makyaj Yapma Zamanından Tasarruf: Kalıcı
                    makyaj, her gün saatlerce makyaj yapma ihtiyacını ortadan
                    kaldırır. Sabahları daha fazla uyumak veya hazırlık süresini
                    azaltmak için zaman kazandırabilir.
                  </li>
                  <li className="list-group-item">
                    ·        Kaş ve Göz Hatlarını Düzeltebilir: Kalıcı makyaj,
                    seyrek kaşları doldurabilir, dengesiz veya kayıp kaşları
                    düzeltebilir ve göz hatlarını belirginleştirebilir. Bu, yüz
                    simetrisini iyileştirir.
                  </li>
                </ul>
                <br />
                <ul className="list-group">
                  <li
                    className="list-group-item active"
                    aria-current="true"
                    style={{ backgroundColor: gold }}
                  >
                    <b>Yosun Peelingin Faydaları</b>
                  </li>
                  <li className="list-group-item">
                    ·        Uygulandıktan sonra cildi katman katman soyar.
                  </li>
                  <li className="list-group-item">
                    ·        Kararmış bölgelerin rengi açılır, cilt
                    pigmentasyonu sağlanır ve cilt tonu eşitlenir.
                  </li>
                  <li className="list-group-item">
                    ·        Kırışıklık ve elastikiyet gibi yaşlanmadan kaynaklı
                    cilt sorunları en aza indirilir.
                  </li>
                  <li className="list-group-item">
                    ·        Akne, leke, skar, yara vb. izler yok olur.
                  </li>
                </ul>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Service;
